import { useState } from "react";
import { useT } from "../i18n";
import { SERVICE_MAP_PAGE, SERVICE_MADANG_PAGE } from "./externalApps";

/**
 * 헤더 메뉴의 Service 항목. 누르면 바로 아래로 서비스별 소개 페이지 목록이 펼쳐진다.
 * Service 자체는 여닫기만 해서 href 를 두지 않는다
 * (index.html 의 <base href="/"> 때문에 href="#" 은 홈으로 전체 이동한다).
 */
const ServiceMenu = () => {
    const t = useT();
    const [open, setOpen] = useState(false);
    const toggle = () => setOpen((v) => !v);

    return (
        <li className={`service ${open ? "open" : ""}`}>
            <a
                role="button"
                tabIndex={0}
                aria-expanded={open}
                onClick={toggle}
                onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        toggle();
                    }
                }}
            >
                {t("Service")}
            </a>
            {open && (
                <ul className="service_sub">
                    <li>
                        <a href={SERVICE_MAP_PAGE}>{t("Propmate Map")}</a>
                    </li>
                    <li>
                        <a href={SERVICE_MADANG_PAGE}>{t("Madang")}</a>
                    </li>
                </ul>
            )}
        </li>
    );
};

export default ServiceMenu;
